module.exports = __webpack_public_path__ + "img/sms-ad.8516ba02.svg";